<template>
  <fieldset class="step step--9">
    <Section :title="stepTitle">
      <CertificationFormGroup name="affirmation" :can-moderate="false">
        <template slot-scope="{ validator }">
          <AgreementControl
            id="affirmation"
            v-model="form.affirmation"
            label="Oświadczam, że podane przeze mnie w formularzu dane są zgodne z prawdą."
            number="1"
            :disabled="formDisabled"
            short-text=""
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>

      <CertificationFormGroup name="agreementChange" :can-moderate="false">
        <template slot-scope="{ validator }">
          <AgreementControl
            id="agreementChange"
            v-model="form.agreementChange"
            label="Przyjmuję do wiadomości, że ocena zgłoszonego wydarzenia będzie oparta o dane podane przeze mnie w niniejszym formularzu, a w przypadku jakiejkolwiek zmiany tych danych, konieczna będzie ponowna weryfikacja zgłoszonego wydarzenia. Zobowiązuję się do niezwłocznego poinformowania o każdej zmianie danych podanych w formularzu."
            number="2"
            :disabled="formDisabled"
            short-text=""
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>
      <!-- <CertificationFormGroup name="agreement" :can-moderate="false">
        <template slot-scope="{ validator }">
          <AgreementControl
            id="agreement"
            v-model="form.agreement"
            label="Klauzule RODO"
            number="4"
            short-text="Oświadczam, że..."
            full-text="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit ut eaque repudiandae provident quis, rerum fuga ipsam dolores in eum voluptas exercitationem quo dignissimos, nesciunt impedit facere architecto, quos laudantium suscipit ratione. Maiores, atque alias expedita dignissimos ex. Quod, molestiae."
            :disabled="formDisabled"
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup> -->
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import AgreementControl from "@/components/Controls/AgreementControl";

export default {
  name: "CertificationFormStep9",
  components: {
    AgreementControl
  },
  extends: BaseCertificationFormStep
};
</script>
